// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"113":"logout","138":"profile","164":"terms","353":"contact","472":"settings","594":"about","957":"privacy","966":"login"}[chunkId] + "." + {"113":"31b7da08","138":"72af5539","164":"5a87d248","353":"a318de40","472":"0a595e1b","594":"a830e5f6","957":"7981633c","966":"eba8fa02"}[chunkId] + ".js";
};